// ContactService.js - Service for contact form submissions
import { BaseService } from './BaseService';
import { createLogger } from './Debug';

const log = createLogger('ContactService');

export class ContactService extends BaseService {
  constructor() {
    super();
  }

  /**
   * Send a contact message
   * @param {string} email - User's email address
   * @param {string} subject - Message subject
   * @param {string} message - Message content
   * @returns {Promise<Object>} Response with success status and message
   */
  async sendContactMessage(email, subject, message) {
    try {
      log.debug('Sending contact message', { email, subject });

      const response = await this.post('/contact', {
        email,
        subject,
        message
      }, {
        skipAuth: true // Public endpoint, no authentication required
      });

      log.debug('Contact message sent successfully', response);
      return response;
    } catch (error) {
      log.error('Failed to send contact message', error);
      throw error;
    }
  }
}
